module.exports = __webpack_public_path__ + "img/male_S_03.930009e3.png";